<template>
    <div class="min-h-screen bg-black text-white flex items-center justify-center">
      <div class="max-w-md w-full px-6 py-8 bg-gray-900 rounded-lg">
        <h1 class="text-2xl font-bold text-center mb-8">登录</h1>
        
        <form @submit.prevent="handleLogin" class="space-y-6">
          <div>
            <label class="block mb-2">用户名</label>
            <input v-model="username" type="text" class="w-full bg-gray-800 rounded px-4 py-2">
          </div>
  
          <div>
            <label class="block mb-2">密码</label>
            <input v-model="password" type="password" class="w-full bg-gray-800 rounded px-4 py-2">
          </div>
  
          <button type="submit" class="w-full bg-yellow-500 text-black py-2 rounded">
            登录
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import request from '@/utils/request'
  
  const store = useStore()
  const router = useRouter()
  const username = ref('')
  const password = ref('')
  
  const handleLogin = async () => {
    try {
      const formData = new FormData()
      formData.append('username', username.value)
      formData.append('password', password.value)
      
      const res = await request.post('/auth/login', formData)
      console.log(res)
      if (res.data.access_token) {
        store.commit('setToken', res.data.access_token)
        alert('登录成功')
        router.push('/')
      }
    } catch (error) {
      alert('登录失败')
    }
  }
  </script>